import _defineProperty from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import { resetComponent } from '../../style';
import { genCollapseMotion } from '../../style/motion';
import { genStyleHooks, mergeToken } from '../../theme/internal';
import genDraggerStyle from './dragger';
import genListStyle from './list';
import genMotionStyle from './motion';
import { genPictureCardStyle, genPictureStyle } from './picture';
import genRtlStyle from './rtl';
var genBaseStyle = function genBaseStyle(token) {
  var componentCls = token.componentCls,
    colorTextDisabled = token.colorTextDisabled;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), Object.assign(Object.assign({}, resetComponent(token)), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, componentCls, {
    outline: 0,
    "input[type='file']": {
      cursor: 'pointer'
    }
  }), "".concat(componentCls, "-select"), {
    display: 'inline-block'
  }), "".concat(componentCls, "-hidden"), {
    display: 'none'
  }), "".concat(componentCls, "-disabled"), {
    color: colorTextDisabled,
    cursor: 'not-allowed'
  })));
};
export var prepareComponentToken = function prepareComponentToken(token) {
  return {
    actionsColor: token.colorTextDescription
  };
};
// ============================== Export ==============================
export default genStyleHooks('Upload', function (token) {
  var fontSizeHeading3 = token.fontSizeHeading3,
    fontHeight = token.fontHeight,
    lineWidth = token.lineWidth,
    controlHeightLG = token.controlHeightLG,
    calc = token.calc;
  var uploadToken = mergeToken(token, {
    uploadThumbnailSize: calc(fontSizeHeading3).mul(2).equal(),
    uploadProgressOffset: calc(calc(fontHeight).div(2)).add(lineWidth).equal(),
    uploadPicCardSize: calc(controlHeightLG).mul(2.55).equal()
  });
  return [genBaseStyle(uploadToken), genDraggerStyle(uploadToken), genPictureStyle(uploadToken), genPictureCardStyle(uploadToken), genListStyle(uploadToken), genMotionStyle(uploadToken), genRtlStyle(uploadToken), genCollapseMotion(uploadToken)];
}, prepareComponentToken);